import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check_active",
  "use": "check_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"check_active\"><path fill-rule=\"evenodd\" d=\"m7.253 14.336 1.372-.117L4.5 10.321v1.46l3.617 3.593 7.383-8.71V4.97z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol